import { buildDesignDnaFigmaPublishAgentQuestion } from './buildDesignDnaFigmaPublishAgentQuestion.js'

const FIGMA_PUBLISH_LABELS = buildDesignDnaFigmaPublishAgentQuestion().options.map((o) =>
  o.label.trim().toLowerCase(),
)

/** @param {string} trimmed */
export function isDesignDnaFigmaPublishPrompt(trimmed) {
  const normalized = trimmed.trim().replace(/\s+/g, ' ').toLowerCase()
  return FIGMA_PUBLISH_LABELS.includes(normalized)
}

/**
 * @param {unknown[]} priorMessages
 * @returns {boolean}
 */
export function threadAwaitingDesignDnaFigmaPublish(priorMessages) {
  if (!Array.isArray(priorMessages) || priorMessages.length === 0) return false

  for (let i = priorMessages.length - 1; i >= 0; i--) {
    const message = priorMessages[i]
    if (!message || typeof message !== 'object') continue

    const role = /** @type {{ role?: string }} */ (message).role
    if (role !== 'assistant') continue

    const assistant = /** @type {{
      designDnaFigmaPublishCompleted?: boolean
      agentQuestion?: { kind?: string, status?: string }
    }} */ (message)

    if (assistant.designDnaFigmaPublishCompleted) return false

    const question = assistant.agentQuestion
    if (question?.kind === 'designDnaFigmaPublish' && question?.status === 'answered') {
      return true
    }

    return false
  }

  return false
}

export const DESIGN_DNA_FIGMA_ENTERPRISE_DASHBOARD_LABEL = 'Enterprise Dashboard Kit'
